import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      username: localStorage['username'],
      email: localStorage['email'],
      avatar_url: localStorage['avatar_url'],
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
